<template>
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    overflow="visible"
    preserveAspectRatio="none"
    viewBox="0 0 22 22"
    :height="height"
    :width="width"
  >
    <g transform="translate(1, 1)">
      <g
        fill-rule="evenodd"
        fill="none"
        stroke-width="1"
        stroke="none"
        id="icon/other/social/yooutube_1598908828442"
      >
        <path
          :fill="iconColor ? iconColor : '#c4302b'"
          id="Combined-Shape_1598908828442"
          d="M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10.1838111,5.79576734 L9.89307716,5.79576843 C9.34067689,5.79795665 7.30559006,5.81327418 5.88198758,5.92049689 C5.65093168,5.94857143 5.14496894,5.95180124 4.69279503,6.44447205 C4.3373913,6.82 4.22149068,7.67354037 4.22149068,7.67354037 C4.22149068,7.67354037 4.10236025,8.67465839 4.10236025,9.67652174 L4.10236025,10.6151553 C4.10236025,11.6175155 4.22149068,12.6195031 4.22149068,12.6195031 C4.22149068,12.6195031 4.3373913,13.4721739 4.69279503,13.8477019 C5.14496894,14.3407453 5.73913043,14.3249689 6.00248447,14.3763975 C6.9176575,14.4680346 9.82073932,14.498914 10.026935,14.5010028 L10.075459,14.5010021 C10.3904424,14.4998168 12.650488,14.4874002 14.1950311,14.3720497 C14.426087,14.3432298 14.931677,14.3407453 15.3838509,13.8473292 C15.7391304,13.4718012 15.8546584,12.6191304 15.8546584,12.6191304 C15.8546584,12.6191304 15.973913,11.6175155 15.973913,10.6151553 L15.973913,9.67652174 C15.973913,8.67465839 15.8546584,7.67304348 15.8546584,7.67304348 C15.8546584,7.67304348 15.7391304,6.81950311 15.3838509,6.44397516 C14.931677,5.95180124 14.426087,5.94857143 14.1950311,5.92012422 C12.769299,5.81322094 10.7357333,5.79794904 10.1838111,5.79576734 Z M8.81242236,8.27614907 L12.0198758,10.0216149 L8.81242236,11.7540373 L8.81242236,8.27614907 Z"
          vector-effect="non-scaling-stroke"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "youtubeIcon",
  props: ["height", "width", "iconColor"],
};
</script>

<style scoped>
</style>
